import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { I18nModule, Product } from '@spartacus/core';
import { IconModule, MediaModule } from '@spartacus/storefront';
import { GenGreenCheckIconComponent } from 'src/app/generac/shared/components/green-check-icon/green-check-icon.component';
import { GenSharedModule } from 'src/app/generac/shared/shared.module';
import { GenAddToCartModule } from '../../cart/product-add-to-cart/product-add-to-cart.module';

@Component({
    selector: 'gen-sp-info',
    templateUrl: './sp-info.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
      CommonModule,
      I18nModule,
      GenSharedModule,
      IconModule,
      MediaModule,
      GenGreenCheckIconComponent,
      GenAddToCartModule,
    ],
})
export class GenSpInfoComponent {
  @Input() servicePart: Product;
  @Input() onHand: boolean;
}
